import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FileItem } from '../../models';

@Component({
  selector: 'evi-desktop-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileListComponent {
  public readonly selectFile = output<FileItem>();
  public readonly selectFolder = output<FileItem>();

  public authorization = input<{ active: boolean, hasUnauthorizedError?: boolean }>({ active: false, hasUnauthorizedError: false });
  public acceptedExtensions = input<string[]>([]);
  public list = input<FileItem[]>([]);
  public emptyText = input<string>('');
  public isFile = input<(item: FileItem) => boolean>(() => true);
  public isFolder = input<(item: FileItem) => boolean>(() => false);

  public trackByName(idx: number, file: FileItem): string {
    return `${file.name}-${idx}`;
  }

  public isValidExtension(file: FileItem): boolean {
    return this.acceptedExtensions().some((ext: string) => file.name?.toLowerCase().includes(ext.toLowerCase()));
  }

  public onFileSelection(file: FileItem): void {
    if (!this.isValidExtension(file)) {
      return;
    }

    this.selectFile.emit(file);
  }

  public onFolderSelection(folder: FileItem): void {
    this.selectFolder.emit(folder);
  }
}
